export const SUPPORTED_VIZ_PROPERTIES = [
    'color',
    'filter',
    'order',
    'resolution',
    'strokeColor',
    'strokeWidth',
    'symbol',
    'symbolPlacement',
    'transform',
    'width'
];

export const STYLE_VIZ_PROPERTIES = [
    'color',
    'filter',
    'order',
    'strokeColor',
    'strokeWidth',
    'symbol',
    'symbolPlacement',
    'transform',
    'width'
];

export const MIN_RESOLUTION = 0;
export const MAX_RESOLUTION = 256;
